import angular from 'angular';
import multiLoanCpaModal from './multiLoanCpaModal';

export default angular
  .module('components.multiLoanCpaModal', [])
  .component('multiLoanCpaModal', multiLoanCpaModal).name;
